import CardSpectacle from 'components/common/CardSpectacle';
import CardSpectacleList from 'components/common/CardSpectacleList';
import styles from './UpcomingSpectaclesBlock.module.css'; // crée-le ensuite
import { ReactComponent as ArrowForwardOutlineIcon } from 'icons/arrow-forward-outline.svg';

export default function UpcomingSpectaclesBlock({ type, spectacleFeatured, spectacles }) {

  const typeCode = spectacleFeatured?.typeShow?.code;
  const typeClass = typeCode === 'spectacle'
    ? styles.upcomingSpectacle
    : typeCode === 'concert'
      ? styles.upcomingConcert
      : '';
  const titleMap = {
    spectacle: 'Spectacles à venir',
    concert: 'Concerts à venir',
  };
  const title = titleMap[type] || 'Événements à venir';

  const linkMap = {
    spectacle: 'Tous les spectacles',
    concert: 'Tous les concerts',
  };
  const linkAll = linkMap[type] || 'Tous les événements';

  const hasFeatured = spectacleFeatured && spectacleFeatured.id;

  console.log('✅ PROPS RECUS', type, spectacles);

  return (

    <section className={`global-section ${styles.section} ${typeClass}`}>
      <div className={`global-container ${styles.content}`}>
        <div className={styles.header}>
          <h2>{title}</h2>
          <div className={styles.linkWrapper}>
            <a href={`/programme/${type}`} className={styles.link} aria-label={`Voir tous les ${type === 'spectacle' ? 'spectacles' : 'concerts'} de la programmation`}>
              {linkAll} <ArrowForwardOutlineIcon className={styles.icon} />
            </a>
          </div>
        </div>

        <div className={`${styles.grid} ${hasFeatured ? styles.hasFeatured : ''}`}>
          {spectacleFeatured && spectacleFeatured.id && (
            <div className={styles.featured}>
              <ul className={styles.spectacleList}>
                <CardSpectacle
                  key={spectacleFeatured.id}
                  name={spectacleFeatured.name}
                  plage_date={spectacleFeatured.plage_date}
                  description={spectacleFeatured.shortDescription}
                  poster={spectacleFeatured.poster}
                  typeShow={spectacleFeatured.typeShow}
                  link={`/programme/${spectacleFeatured.typeShow?.code}/${spectacleFeatured.slug}`}
                  isFeatured={spectacleFeatured.featured}
                />
              </ul>
            </div>
          )}

          <div className={styles.list}>
            {spectacles.slice(0, 4).map((show) => (
              <CardSpectacleList
                key={show.id}
                name={show.name}
                plage_date={show.plage_date}
                poster={show.poster}
                typeShow={show.typeShow}
                link={`/programme/${show.typeShow?.code}/${show.slug}`}
              />
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
